export default function({ changes }){
  return this.takeAction('updateOrganizationsAccountData', { organizationApikeys: 'all', changes })
}
